import { useTranslation } from 'react-i18next'

import IconButton from 'src/components/atoms/iconButton'
import { CrossIcon } from 'src/components/icons'
import Modal from 'src/components/molecules/modal'
import ActionToolbar from 'src/components/organisms/actionToolbar'

import { FullScreenModalProps } from './types'

import { Typography } from 'antd'

const { Title } = Typography

const FullScreenModal = (props: FullScreenModalProps) => {
    const { open, title, actions, children, onClose, afterClose, hideCloseButton, ...rest } = props

    const { t } = useTranslation()

    const runningStorybook = import.meta.env.STORYBOOK_RUNNING === 'true'
    const container = runningStorybook ? document.getElementById('storybook-root') : null

    return (
        <Modal
            {...rest}
            zIndex={1001} // Set z-index to 1001 to ensure the modal is always on top of other modals, but below the notifications/**/
            open={open}
            // Storyshots can't attach the drawer to the body, so we attach it to a div with a known id
            getContainer={container}
            footer={null}
            destroyOnClose
            closeIcon={false} // Don't render modal's close icon for alignment issue, replaced by IconButton in modal's title
            afterClose={afterClose}
            classNames={{
                header: '!mb-0 !p-5 !drop-shadow-md',
                content: '!p-0 overflow-hidden flex flex-col h-[calc(100vh-4rem)]',
                body: 'overflow-hidden bg-white h-full flex-1 flex flex-col',
            }}
            className="relative inset-x-0 inset-y-0 !m-0 h-full !w-full !max-w-none overflow-hidden !p-8"
            title={
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <Title className="!m-0 flex flex-1 items-center justify-between !text-gray-600" level={3}>
                        {title}
                    </Title>
                    <div className="mt-2 flex items-center justify-between sm:mt-0 sm:justify-end">
                        <ActionToolbar actions={actions} />
                        <IconButton
                            hidden={hideCloseButton}
                            type="text"
                            className="ml-2 p-0 text-gray-400"
                            onClick={onClose}
                            title={t('Close')}
                            icon={<CrossIcon size="xl" />}
                        />
                    </div>
                </div>
            }
        >
            <div className="flex h-full flex-col overflow-auto">{children}</div>
        </Modal>
    )
}

export default FullScreenModal
